import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import '../styles/BookingSection.css';

const BookingSection = () => {
  return (
    <ScrollReveal> {/* Wrap the entire section inside ScrollReveal */}
    <section className="booking-section">
      <motion.div
        className="booking-content"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
      >
        <motion.h2
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          Ready to Turn Your Dreams into Reality?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          Let’s Make a Deal and Bring Your Vision to Life
        </motion.p>
        <motion.a
          href="/contact"
          className="booking-button"
          whileHover={{ scale: 1.15, boxShadow: '0 0 20px rgba(230, 0, 35, 0.8)' }}
          whileTap={{ scale: 0.95 }}
        >
          Book a Consultation
        </motion.a>
      </motion.div>
    </section>
    </ScrollReveal> 
  );
};

export default BookingSection;
